import React from "react";
import Snackbar from "@mui/material/Snackbar";
import {Alert} from "@mui/material";

type ErrorMessageProps = {
    handleClose: () => void,
    isOpen: boolean,
    message?: string,
}


export const ErrorMessage = (props: ErrorMessageProps) => {
    const {handleClose: _handleClose, isOpen, message} = props

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        _handleClose();
    };

    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            <Alert severity="error" onClose={handleClose}>{message}</Alert>
        </Snackbar>
    )
}
